import { Button, Col, Row, Space, Typography } from "antd";
import React from "react";
import ArrowGreen from "@assets/svg/arrow-right.svg";
import { classNames } from "@features/utils/reactFunctions";
import * as styles from "./SelectBoxStyle.module.scss";

type Props = {
  icon: React.ReactNode;
  title: string;
  footer: { label: React.ReactNode; value: string }[];
  onClick: Function;
  disabled?: boolean;
};

const SelectBox = ({
  icon,
  title,
  footer,
  onClick,
  disabled = false,
}: Props) => {
  return (
    <div
      className={classNames(
        disabled && styles.selectBoxDisabled,
        styles.selectBox
      )}
    >
      <Row onClick={() => onClick()}>
        <Col xs={4}>{icon}</Col>
        <Col xs={18}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Typography className={styles.selectBoxTitle}>{title}</Typography>

            <Space>
              {footer.map(({ label, value }) => (
                <Space wrap={false}>
                  <Typography className={styles.selectBoxFooterLabel}>
                    {label}
                  </Typography>
                  <Typography className={styles.selectBoxFooterValue}>
                    {value}
                  </Typography>
                </Space>
              ))}
            </Space>
          </Space>
        </Col>
        <Col xs={2}>
          <Button icon={<ArrowGreen />} onClick={() => {}} type="link" />
        </Col>
      </Row>
    </div>
  );
};

export default SelectBox;
